import { useEffect } from 'react';

/**
 * Fade + slide-in on scroll. Adds `.is-in` to every `.reveal` in the
 * document once it crosses the viewport. Runs once per mount — pages
 * re-run it via the pathname dep so freshly routed content animates too.
 */
export function useReveal(dep?: unknown): void {
  useEffect(() => {
    const nodes = document.querySelectorAll<HTMLElement>('.reveal:not(.is-in)');
    if (nodes.length === 0) {
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach((n) => io.observe(n));
    return () => io.disconnect();
  }, [dep]);
}
